<script>
  import solicitacaoCores from '~js/solicitacao-cores';

  export default {
    components: { 
      alert, 
    },
    props: {
      itens: Array,
      carregando: {
        type: Boolean,
        required: false,
        default: false
      },
      titleCard: String,
      textoBotao: String,
      rotaBotao: String,
      semItemTexto: String,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        solicitacaoCores: solicitacaoCores,
      }
    },
    methods: {
      retornaClassIcone(modulo) {        
        return this.solicitacaoCores.filter(s => s.id == modulo)[0].icone;
      },
      retornaClassCor(modulo, comAlfa) {
        return comAlfa ?  this.solicitacaoCores.filter(s => s.id == modulo)[0].cor + "b0" : this.solicitacaoCores.filter(s => s.id == modulo)[0].cor; 
      },
    },
    computed: {
        mostrarItens() {
            return this.itens.length > 0;
        }
    }
  }
</script>

<template>
    <div class="col-lg-4">
        <div class="ibox ">
            <div class="ibox-title">
                <h5 class="MuiTypography-h6">{{titleCard}}</h5>
            </div>
            <div class="ibox-content" style="padding: 0px 15px 15px;">
                <div class="feed-activity-list">
                    <div class="TextoListagem text-center" v-if="carregando" style="margin-top: 12px;">
                        <i class='fa fa-spinner fa-pulse'></i>  Carregando...
                    </div>                    
                    <div v-else class="feed-element" style="padding-bottom: 0px;">
                        <ul class="list-group clear-list" style="margin-bottom: 0px;">                            
                            <li class="list-group-item fist-item" v-if="!mostrarItens" style="padding-top: 3px;">
                                <span class="TextoListagem">{{semItemTexto}}</span>
                            </li>
                            <li :class="['list-group-item TextoListagem', { 'fist-item' : index == 0 }]" v-for="(item, index) in itens">                                
                                <div class="TextoListagem">
                                    <i :class="retornaClassIcone(item.modulo)" :style="{ color: retornaClassCor(item.modulo) }"></i> {{ item.descricao }}
                                
                                    <span class="label TextoQuantidades" :style="{ 'float': 'right', 'color': 'white', 'background-color' : retornaClassCor(item.modulo,1) }">{{item.quantidade}}</span> 
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <router-link 
                            class="btn btn-primary btn-block m-t"
                            tag="button" 
                            tabindex="0" 
                            type="button"
                            :to="rotaBotao">

                        <span class="MuiButton-label">{{textoBotao}}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
   .MuiTypography-h6 {
        font-size: 1.7rem;
        font-family: 'Maven Pro', sans-serif;
        font-weight: 550;
  } 

  .TextoListagem {
        font-size: 16px;
        font-family: 'Maven Pro', sans-serif;
  } 

  .TextoQuantidades {
        font-size: 13px;
  } 
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/notificacoes/componentes/CardNotificacao.vue